module.exports = {"translations":{"step-loader-organization":"Overfører medlemsinfo $[organizationName] til prisberegner","step-loader-student":"Du kan få studierabat på din forsikring"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/packages/travel/cu/package.travel-tjm-text.json
// module id = 698
// module chunks = 0